import VideoContainer from "./VideoContainer";
import classes from "./VideoSection.module.scss";
import { AppState } from "@Store/index";
import { useRef } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { allVideoElementWithoutYoutube } from "../SectionFeatured.tsx/utils";
import wrapperHOC from "@Utils/wrapperHOC";

const VideoSection = () => {
  const { data } = useSelector(
    ({ propertyPageData }: AppState) => ({
      data: propertyPageData.data,
    }),
    shallowEqual,
  );

  const showVideoTour: any = allVideoElementWithoutYoutube(data);
  const videoSectionRef = useRef(null);

  const shouldShowVideoSection = showVideoTour.length >= 3;

  return (
    <>
      {shouldShowVideoSection && (
        <>
          <div className={classes.parentContainer} ref={videoSectionRef} id="video_tour">
            <VideoContainer />
          </div>
        </>
      )}
    </>
  );
};

export default wrapperHOC(VideoSection, {
  componentName: "VideoSection-PropertyPage",
  showForChina: true,
});
